import tinytime from 'tinytime'

const n2 = (n) => (n < 10 ? '0' + n : n)
const tinyTimeOptions = {
    padMonth: true,
    padDays: true,
    padHours: true
}

export const date = function (value, noYear = false) {
    let format = noYear ? '{Mo}-{DD}' : '{YYYY}-{Mo}-{DD}'
    if (value) {
        const template = tinytime(format, tinyTimeOptions)
        return template.render(new Date(+value))
    } else {
        return '--'
    }
}

export const time = function (value) {
    let format = '{Mo}月{DD}日, {a}{h}:{mm}'
    console.log(value)
    if (value) {
        let today = new Date()
        today.setHours(0)
        today.setMinutes(0)
        today.setSeconds(0)
        let offset = today.getTime() - value
        if (offset <= 0) {
            format = '{a}{h}:{mm}'
        }
        const template = tinytime(format, { padMonth: false, padDays: false, padHours: false })
        let result = template.render(new Date(+value))
        return result.replace('PM', '下午').replace('AM', '上午')
    } else {
        return '--'
    }
}

export const datetime = function (value, noYear = false) {
    if (value) {
        let format = noYear ? '{Mo}-{DD} {H}:{mm}' : '{YYYY}-{Mo}-{DD} {H}:{mm}:{ss}'
        const template = tinytime(format, tinyTimeOptions)
        return template.render(new Date(+value))
    }
}

export const datetime1 = function (value) {
    if (value) {
        let format = '{YYYY}-{Mo}-{DD} {H}:{mm}'
        const template = tinytime(format, tinyTimeOptions)
        return template.render(new Date(+value))
    }
}

export const datetime2 = function (value) {
    if (value) {
        let format = '{YYYY}/{Mo}/{DD} {H}:{mm}'
        const template = tinytime(format, tinyTimeOptions)
        return template.render(new Date(+value))
    }
}

export const playerTime = function (seconds) {
    if (seconds) {
        let minutes = parseInt(seconds / 60)
        seconds = seconds % 60
        if (minutes < 60) {
            return n2(minutes) + ':' + n2(seconds)
        } else {
            let hours = parseInt(minutes / 60)
            minutes = minutes % 60
            return hours + ':' + n2(minutes) + ':' + n2(seconds)
        }
    } else {
        return '00:00'
    }
}

export const num = function (value, count = 2) {
    return value.toFixed(count)
}

export const n0 = function (value) {
    return Math.floor(value)
}

export const percent = function (value, count = 2, suffix = '%') {
    if (value === null || isNaN(value)) {
        return '--'
    } else {
        let prefix = value > 0 ? '+' : ''
        return prefix + (value * 100).toFixed(count) + suffix
    }
}

export const color = function (value) {
    if (value > 0) {
        return 'red'
    } else if (value < 0) {
        return 'green'
    }
}

export const bg = function (value) {
    return {
        backgroundImage: 'url(' + value + ')',
        backgroundSize: 'cover'
    }
}

export const len = function (value, len) {
    if (value && value.length > len) {
        return value.substr(0, len) + '...'
    } else {
        return value
    }
}

export const formatTime = function (secondsNum) {
    var nums = secondsNum <= 0 ? 0 : secondsNum
    var hours = Math.floor(nums / 3600)
    var minutes = Math.floor((nums % 3600) / 60)
    var seconds = Math.floor(nums % 60)

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

export const formatTime2 = function (secondsNum) {
    var nums = secondsNum <= 0 ? 0 : secondsNum
    var hours = Math.floor(nums / 3600)
    var minutes = Math.floor((nums % 3600) / 60)
    var seconds = Math.floor(nums % 60)

    return `${String(hours).padStart(2, '0')}${String(minutes).padStart(2, '0')}${String(seconds).padStart(2, '0')}`
}

export const ymdTime = function (value) {
    let format = '{YYYY}年{Mo}月{DD}日 {a}{h}:{mm}'
    if (value) {
        let today = new Date()
        today.setHours(0)
        today.setMinutes(0)
        today.setSeconds(0)
        let offset = today.getTime() - value
        if (offset <= 0) {
            format = '{a}{h}:{mm}'
        }
        const template = tinytime(format, { padMonth: false, padDays: false, padHours: false })
        let result = template.render(new Date(+value))
        return result.replace('PM', '下午').replace('AM', '上午')
    } else {
        return '--'
    }
}

export function formatSecondsToTime(seconds) {
    // 计算天数
    const days = Math.floor(seconds / (24 * 60 * 60))
    // 计算剩余秒数
    const remainingSeconds = seconds % (24 * 60 * 60)
    // 计算小时
    const hours = Math.floor(remainingSeconds / (60 * 60))
    // 计算剩余秒数
    const remainingSecondsAfterHours = remainingSeconds % (60 * 60)
    // 计算分钟
    const minutes = Math.floor(remainingSecondsAfterHours / 60)

    // 补零函数：不足两位数前面补0，超过两位数不处理
    const pad = (num) => String(num).padStart(2, '0')

    return `${pad(days)}:${pad(hours)}:${pad(minutes)}`
}
